'use strict';

var inflect = require('i')();
var moment  = require('moment');

module.exports = {
    getInputValue: function($input) {
        var type       = $input.data('valueType');
        var name       = $input.attr('name');
        var getValueOf = 'getInputValueOf' + inflect.camelize(name || '__');
        var getValueAs = 'getInputValueAs' + inflect.camelize(type || '__');

        if (_.isFunction(this[getValueOf])) {
            return this[getValueOf]($input);
        }

        if (_.isFunction(this[getValueAs])) {
            return this[getValueAs]($input);
        }

        return this.getInputValueAsRaw($input);
    },

    getInputValueAsRaw: function($input) {
        if ($input.attr('type') === 'radio') {
            return this.$('[name="' + $input.attr('name') + '"]:checked').val();
        }

        if ($input.hasClass('js-datepicker')) {
            let m = moment($input.datepicker('getDate'));
            return new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0));
        }

        if ($input.attr('type') === 'checkbox') {
            return $input.is(':checked') ? $input.val() : null;
        }

        if ($input.prop('tagName') === 'SELECT' && $input.attr('multiple')) {
            return $input.val();
        }

        return $.trim($input.val());
    }
};




// WEBPACK FOOTER //
// ./app/commons/viewMixins/InputValueFormat.js